export default __webpack_public_path__ + "static/media/Bitmap_13.73d60907.jpg";